import { reactive } from 'vue'

export const store = reactive({
  path: process.env.VUE_APP_API_URL,
  tok: '',
  reloadPath(path) {
    this.path = path
  },
  reloadTok(tok) {
    this.tok = tok
  }
})